import { formatServicesForAPI } from 'utils';

import {
  AppointmentInterface,
  BookingParams,
  GetAppointmentsParamsInterface,
  SelectedProductType,
  ServiceTypeVariant
} from 'types';

import { get, post } from './axios';

const URLS = {
  getServices: 'get-services',
  getAddons: 'get-addons',
  getProviders: 'get-providers',
  getCategories: 'get-categories',
  getAppointments: 'get-aas-results',
  getApptConfirmationSettings: 'appt-book-prefs',
  getServicesList: 'get-services-list-ext',
  bookingAppointment: 'appt-book',
  updateAppointmentComment: 'update-cl-appt-comment',
  validatePromoCode: 'appt-validate-promo-code',
  calcApptPrice: 'appt-book-calc-price',
  geRecommendations: 'products/appt-items',
  getApptDepositPrefs: 'get-appt-deposit-prefs'
};

const servicesApi = {
  getServicesByLocId: (
    catid: number | null,
    locid: number,
    get_master_svc: number = 0
  ) => get(URLS.getServices, { catid, locid, get_master_svc }),
  getCategoriesByLocId: (locid: number) => get(URLS.getCategories, { locid }),
  getAddons: (locid: number, svcid: number) =>
    get(URLS.getAddons, { locid, svcid }),
  getProviders: (locid: number, svcid: number) =>
    get(URLS.getProviders, { locid, svcid }),
  getServicesList: (locid: number, type?: ServiceTypeVariant) =>
    get(URLS.getServicesList, { locid, list_type: type }),
  getApptConfirmationSettings: () => get(URLS.getApptConfirmationSettings),
  getAppointments: (params: GetAppointmentsParamsInterface) =>
    get(URLS.getAppointments, {
      ...params,
      services: formatServicesForAPI(params.services)
    }),
  bookingAppointment: (params: BookingParams) =>
    post(URLS.bookingAppointment, params),
  updateAppointmentComment: (appt_id: number, comment: string) =>
    post(URLS.updateAppointmentComment, { appt_id, comment }),
  validatePromoCode: (promoCode: string, appt: AppointmentInterface) =>
    post(URLS.validatePromoCode, { promo_code: promoCode, appt }),
  calcApptPrice: (
    appt: AppointmentInterface,
    locationId: number,
    attendees: number[]
  ) => post(URLS.calcApptPrice, { appt, locid: locationId, attendees }),
  geRecommendations: (appt_id: number) =>
    get(URLS.geRecommendations, { appt_id }),
  buyRecommendedProducts: (pr_data: SelectedProductType[], apptId: number) =>
    post(URLS.geRecommendations, { pr_data, appt_id: apptId }),
  getApptDepositPrefs: (svc_list: (string | number)[], locid: number) =>
    get(URLS.getApptDepositPrefs, { svc_list, locid })
};

export default servicesApi;
